/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */

/* eslint-disable react/no-unused-prop-types */
'use es6'; // A component that will only show its child
// if you have the ads write scope, or if a tooltipKey is specified, will
// wrap the child in the tooltip.
// tooltip is useful for the pattern where you want to disable a child button
// but still show it and give a tooltip that says you don't have permissions
// to use the button

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { cloneElement } from 'react';
import { connect } from 'react-redux';
import { Scopes } from 'AdsUI/lib/Scopes';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import I18n from 'I18n';
import { getScopes } from 'AdsUI/selectors/AuthSelectors';
import SafeTooltip from './SafeTooltip';
import { usageTracker } from 'AdsUI/lib/usageTracker';

const getNoPermissionMsg = tooltipKey => {
  const actionString = I18n.text(`noWritePermission.actions.${tooltipKey}`);

  const tooltipTitle = /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "noWritePermission.notAuthorized",
    options: {
      action: actionString
    }
  });

  return tooltipTitle;
};

const ScopeWrapper = ({
  children,
  tooltipKey,
  disabled
}) => {
  if (!disabled) {
    return children;
  } else if (tooltipKey) {
    // Wrap children in a span because often times the child is a `disabled`
    // element which usually does not trigger the tooltip
    return /*#__PURE__*/_jsx(SafeTooltip, {
      onOpenChange: event => {
        const isOpen = event.target.value;

        if (isOpen) {
          usageTracker.track('accessRequestTooltip', {
            key: tooltipKey
          });
        }
      },
      title: getNoPermissionMsg(tooltipKey),
      children: /*#__PURE__*/cloneElement(children, {
        disabled
      })
    });
  }

  return null;
};

const ScopesPropType = PropTypes.oneOfType([PropTypes.arrayOf(propValue => {
  return Object.values(Scopes).indexOf(propValue) > -1;
})]);
ScopeWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  tooltipKey: PropTypes.string,
  andScopes: ScopesPropType,
  orScopes: ScopesPropType
};

const mapStateToProps = (state, props) => {
  const {
    andScopes,
    orScopes
  } = props;

  if (andScopes && orScopes) {
    throw new Error('Must have either andScopes or orScopes');
  }

  const scopes = getScopes(state);

  if (orScopes) {
    return {
      disabled: !orScopes.some(scope => scopes.indexOf(scope) !== -1)
    };
  }

  const requiredScopes = props.andScopes || [Scopes.ADS_WRITE];
  return {
    disabled: !requiredScopes.every(scope => scopes.indexOf(scope) !== -1)
  };
};

export default connect(mapStateToProps)(ScopeWrapper);